// extracted by mini-css-extract-plugin
module.exports = {"HistoryCard":"history_HistoryCard__3WpGC","HistoryLine":"history_HistoryLine__3T44b","HistoryLineBold":"history_HistoryLineBold__29sTv","Title":"history_Title__3DMSN"};